import dexieService from '../services/dexieService'

export const saveToStorage = async (data) => {
  try {
    const { products, purchases, nextProductId, nextClientId, shopInfo } = data

    await dexieService.saveProducts(products)
    await dexieService.savePurchases(purchases)
    await dexieService.saveMetadata('nextProductId', nextProductId)
    await dexieService.saveMetadata('nextClientId', nextClientId)

    if (shopInfo) {
      await dexieService.saveShopInfo(shopInfo)
    }

    return true
  } catch (error) {
    console.error('Erreur sauvegarde:', error)
    return false
  }
}

export const loadFromStorage = async () => {
  try {
    const products = await dexieService.getAllProducts()
    const purchases = await dexieService.getAllPurchases()
    const nextProductId = (await dexieService.getMetadata('nextProductId')) || 1
    const nextClientId = (await dexieService.getMetadata('nextClientId')) || 1
    const shopInfo = await dexieService.getShopInfo()

    return {
      products,
      purchases,
      nextProductId,
      nextClientId,
      shopInfo,
    }
  } catch (error) {
    console.error('Erreur chargement:', error)
    return {
      products: [],
      purchases: [],
      nextProductId: 1,
      nextClientId: 1,
      shopInfo: null,
    }
  }
}

export { dexieService }
